<script lang="ts">
  import { useNavigate } from 'svelte-navigator';
  import ThemedIcon from './ThemedIcon.svelte';

  const navigate = useNavigate();
  export let onClick: () => void = null;
  export let fixed = false;
  export let themed = false;
</script>

<div
  class="back-arrow"
  class:back-arrow-fixed={fixed}
  class:back-arrow-themed={themed}
>
  <ThemedIcon>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      on:click={() => (onClick ? onClick() : navigate(-1))}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289Z"
      />
    </svg>
  </ThemedIcon>
</div>

<style lang="scss">
  .back-arrow {
    position: absolute;
    top: 24px;
    left: 24px;
    cursor: pointer;
  }
  .back-arrow-fixed {
    position: relative;
    top: auto;
    left: auto;
  }

  .back-arrow-themed svg path {
    fill: var(--twism-theme-textAboveBackground) !important;
  }
</style>
